import { useEffect, useId, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { GNB_ITEMS, ROUTES } from '@/constants/site';
import { SiteLink } from './SiteLink';

/**
 * GNB 링크의 현재 위치 표시.
 * 문의 페이지는 Plan 의 하위 흐름이라 'location' 으로 약하게 표시한다
 * (CSS 는 page/location 둘 다 같은 밑줄을 그린다).
 */
function currentState(itemTo, pathname) {
  if (itemTo === pathname) return 'page';
  if (itemTo === ROUTES.plan && pathname === ROUTES.inquiry) return 'location';
  return undefined;
}

function GnbList({ className, pathname, onNavigate }) {
  return (
    <ul className={className}>
      {GNB_ITEMS.map((item) => (
        <li key={item.to}>
          <SiteLink
            className="gnb-link"
            to={item.to}
            aria-current={currentState(item.to, pathname)}
            onClick={onNavigate}
          >
            {item.label}
          </SiteLink>
        </li>
      ))}
    </ul>
  );
}

export function SiteHeader() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const mobileNavId = useId();

  // 라우트가 바뀌면 열려 있던 모바일 메뉴를 닫는다
  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className="site-header">
      <div className="inner header-bar">
        <SiteLink to={ROUTES.index} className="header-logo-link" aria-label="Nova 홈">
          <img
            src="/assets/images/logo-nova.png"
            alt="Nova"
            width="720"
            height="208"
            className="header-logo"
            fetchPriority="high"
          />
        </SiteLink>

        <nav aria-label="주요 메뉴">
          <GnbList className="gnb-list" pathname={pathname} />

          <button
            type="button"
            className="nav-burger"
            aria-label={open ? '메뉴 닫기' : '메뉴 열기'}
            aria-expanded={open}
            aria-controls={mobileNavId}
            onClick={() => setOpen((prev) => !prev)}
          >
            <span className="nav-burger-line" />
            <span className="nav-burger-line" />
            <span className="nav-burger-line" />
          </button>
        </nav>
      </div>

      <div id={mobileNavId} hidden={!open} className="mobile-nav">
        <GnbList
          className="inner mobile-nav-list"
          pathname={pathname}
          onNavigate={() => setOpen(false)}
        />
      </div>
    </header>
  );
}
